const DEDUPE_WINDOW_MS = 60000
const reportState = new Map()

// 寫入前順手清掉過期項目，讓容器大小收斂到「時間窗內實際失敗的 host+endpoint」，
// 不另開 Timer（避免產生需要 ssr-cleanup 處理的副作用）。
function evictExpired(now) {
  for (const [key, state] of reportState) {
    if (now - state.reportedAt >= DEDUPE_WINDOW_MS) {
      reportState.delete(key)
    }
  }
}

// 一次連線劣化會讓 /self 等背景輪詢以「同一個 host+endpoint」持續失敗，若每次失敗都上報，
// 單一使用者的一次斷線即可產生數十筆完全相同的 ERR_998 事件（CLIENT-PWA-SSR-1GF）。
// 時間窗對齊 host.client.js 的 60 秒測線週期：同一週期內選用的 host 不會改變，
// 重複上報不會帶來新資訊，只會稀釋真實錯誤訊號。
// 被擋下的次數會累計成 suppressedCount 隨下一筆上報帶出，避免降噪後看不出故障規模。
// 僅於 client 端節流；SSR render 路徑一律略過，避免模組級狀態跨請求污染。
export function claimErr998ReportSlot(key, now = Date.now()) {
  if (!import.meta.client) {
    return { shouldReport: true, suppressedCount: 0 }
  }
  const state = reportState.get(key)
  if (state && now - state.reportedAt < DEDUPE_WINDOW_MS) {
    state.suppressedCount += 1
    return { shouldReport: false, suppressedCount: state.suppressedCount }
  }
  evictExpired(now)
  reportState.set(key, { reportedAt: now, suppressedCount: 0 })
  return { shouldReport: true, suppressedCount: state?.suppressedCount ?? 0 }
}
